import styled, { css } from 'styled-components';
import Markdown from 'react-markdown';
import { prop } from 'ramda'

import { TRANSPARENT, WHITE, HERO_LINE_COLOR } from '../../utils/colors';
import { ContentContainer, serifFont } from '../layout/layout.styles';
import { ShareButton as ShareButtonComponent } from '../shareButton';
import { media } from '../../utils/media';
import { MAP_HEIGHTS } from '../../templates/homepage/homepage.constants'

export const Cover = styled.div`
  margin-bottom: 47px;
  position: relative;
  line-height: 0;
`;

export const Icon = styled.img`
  display: block;
  position: absolute;
  width: 40px;
  transform: translate(-45px, 47px) scale(0.7);

  ${media.tablet`
    transform: translate(-63px, 38px);
  `}
`;

export const ColombiaIcon = styled.img`
  display: none;
  width: 40px;
  transform: translate(-45px, 47px) scale(0.7);

  ${media.tablet`
    display: block;
    position: absolute;
    width: 80px;
    transform: translate(-120px, 20px);
  `}

  ${media.desktop`
    width: 120px;
    transform: translate(-160px, 10px);
  `}
`;

export const MongoliaIcon = styled.img`
  display: none;

  ${media.tablet`
    display: block;
    position: absolute;
    width: 150px;
    transform: translate(-190px, 15px);
  `}

  ${media.desktop`
    width: 200px;
    transform: translate(-240px, 20px);
  `}
`;

export const SeychellesIcon = styled.img`
  display: none;
  width: 60px;
  transform: translate(-75px, 35px) scale(0.7);

  ${media.tablet`
    display: block;
    position: absolute;
    width: 80px;
    transform: translate(-120px, 0);
  `}

  ${media.desktop`
    width: 120px;
    transform: translate(-160px, 0);
  `}
`;

export const Image = styled.div`
width: 100%;
background: url(${prop('image')}) no-repeat center top;
background-size: cover;
background-position: center;

height: ${MAP_HEIGHTS.mobile}px;

${media.bigMobile`
  height: ${MAP_HEIGHTS.bigMobile}px;
`}

${media.tablet`
  height: calc(100vh - 180px);
`}


@media print {
  height: ${MAP_HEIGHTS.bigMobile}px;
}
`;

export const ImageCaption = styled(Markdown)`
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 3px 7px;
  background-color: ${WHITE};
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2em;

  p {
    margin: 0;
  }
  a {
    text-decoration: none;
  }
`;

export const SectionWrapper = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33em;
  letter-spacing: 0.6px;
  display: flex;
  align-items: center;
`;

export const SectionName = styled.div``;

export const SectionNumber = styled.div`
  margin-left: 20px;
`;

export const ShareButton = styled(ShareButtonComponent)`
  margin-right: 0;
  margin-left: auto;
  cursor: pointer;

  circle {
    fill: ${TRANSPARENT};
  }

  svg {
    width: 30px;
    height: 30px;
  }
`;

export const Title = styled.h1`
  line-height: 1.17;
  font-size: 36px;
  font-weight: 300;
  letter-spacing: -0.24px;
  margin: 20px 0 30px;

  ${media.tablet`
    font-size: 48px;
    line-height: normal;
    margin: 10px 0 30px;
  `};
`;

export const Content = styled(Markdown)`
  ${serifFont}
  font-size: 20px;
  font-weight: 500;
  line-height: 1.6em;
  h3 {
    font-weight: 400;
  }
  h6 {
    font-family: 'FreightText', Georgia, serif;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 32px;
    color: #0F1315;
  }
`;

export const ContentWrapper = styled(ContentContainer)`
  position: relative;
  padding: 0 40px 0 50px;

  display: block;

  ${media.desktop`
      padding-left: 290px;
  `};

  ${media.desktopWide`;
      padding-left: 340px;
  `};
`;

const contentColorsStyles = ({ theme }) => css`
  ${SectionName}, ${Content}, ${ImageCaption}, ${ImageCaption} a {
    color: ${theme.color};
  }

  ${Cover} {
    background-color: ${theme.color};
  }

  ${ShareButton} path {
    fill: ${theme.color};
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 4px solid ${HERO_LINE_COLOR};
  padding: 0 0 26px 0;
  margin-bottom: 65px;

  ${contentColorsStyles}
`;
